import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const mockRows = [
  { id: 1, clientName: 'Hepto', botNumber: '918608221193' },
];

const OnboardPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 64px)',
        backgroundColor: '#f5f5f5',
        display: 'flex',
        justifyContent: 'center',
        p: { xs: 2, md: 3 },
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 1100 }}>
        <Card sx={{ mb: 2, borderRadius: 2, boxShadow: 3 }}>
          <CardContent sx={{ py: 2, px: 3 }}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Button
                variant="text"
                startIcon={<ArrowLeft size={18} />}
                onClick={() => navigate(-1)}
                sx={{ color: 'text.secondary', px: 0, minWidth: 0 }}
              >
                Back
              </Button>
              <Typography variant="h6">Client Details</Typography>
            </Stack>
          </CardContent>
        </Card>

        <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
          <CardContent sx={{ p: 0 }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, width: 120 }}>S.No</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Client Name</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Bot Number</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {mockRows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell>{row.id}</TableCell>
                      <TableCell>{row.clientName}</TableCell>
                      <TableCell>{row.botNumber}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                p: 2,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Page 1 of 1
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default OnboardPage;
